import { render, staticRenderFns } from "./PriceRow.vue?vue&type=template&id=0f35cba6&scoped=true&"
import script from "./PriceRow.vue?vue&type=script&lang=js&"
export * from "./PriceRow.vue?vue&type=script&lang=js&"
import style0 from "./PriceRow.vue?vue&type=style&index=0&id=0f35cba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35cba6",
  null
  
)

export default component.exports